import React from 'react';

const DEFAULT_MAPPING = Object.freeze({});
const DEFAULT_TRANSFORM_FROM_SET_IF_SINGLE = Object.freeze([]);
const DEFAULT_DATE_POSTFIXES = Object.freeze({ before: '_max', after: '_min' });

const UseApiCallParams = (params, mapping = DEFAULT_MAPPING, transformFromSetIfSingle = DEFAULT_TRANSFORM_FROM_SET_IF_SINGLE, datePostfixes = DEFAULT_DATE_POSTFIXES) => {
    const formatDate = obj => {
        if (obj instanceof Date) {
            try {
                return obj.toISOString();
            } catch {
                return null;
            }
        }
        return obj;
    };
    const findMapping = React.useCallback(
        key => {
            if (key !== undefined) {
                const entry = Object.entries(mapping).find(([mappingKey]) => key.startsWith(mappingKey));
                if (entry && typeof entry[1] === 'string') {
                    const [mappingKey, mappedValue] = entry;
                    const remainingPart = key.slice(mappingKey.length);
                    return mappedValue + remainingPart;
                }
                return key;
            }
        },
        [mapping]
    );

    const paramsToApiCallParams = React.useCallback(
        filters => {
            let transformed = {};
            for (let [filterName, filterValue] of Object.entries(filters)) {
                if (['tab', 'page', 'per_page'].includes(filterName)) {
                    continue;
                }
                let toAdd = {};
                filterName = findMapping(filterName);
                if (filterValue.after || filterValue.before) {
                    if (filterValue.before) {
                        let tempKey = filterName + datePostfixes.before;
                        toAdd[mapping[filterName]?.before || tempKey] = formatDate(filterValue.before);
                    }
                    if (filterValue.after) {
                        let tempKey = filterName + datePostfixes.after;
                        toAdd[mapping[filterName]?.after || tempKey] = formatDate(filterValue.after);
                    }
                } else if (filterName === 'ordering') {
                    let columnName = findMapping(filterValue.column);
                    const sign = filterValue.direction === 'DESC' ? '-' : '';
                    if (filterValue.column in mapping) {
                        columnName = mapping[filterValue.column];
                    }
                    toAdd[filterName] = `${sign}${columnName}`;
                } else if (filterName === 'amount') {
                    if (typeof filterValue === 'string') {
                        toAdd[filterName] = filterValue;
                        const amount = parseFloat(filterValue) * 100;
                        toAdd[filterName] = amount.toString();
                    } else {
                        const filteredObj = Object.entries(filterValue).reduce((acc, [amountFilterName, amountValue]) => {
                            if (!isNaN(amountValue)) {
                                acc[amountFilterName] = amountValue;
                            }
                            return acc;
                        }, {});
                        toAdd = { ...filteredObj };
                    }
                } else if (filterName.includes('__in')) {
                    let tempKey = filterName.replace('__in', '');
                    const arrayFromValue = Array.from(filterValue);
                    if (transformFromSetIfSingle.includes(tempKey)) {
                        if (arrayFromValue.length === 1) {
                            filterName = tempKey;
                        }
                    }
                    filterValue = arrayFromValue.join(',');
                    toAdd[filterName] = filterValue;
                } else {
                    toAdd[filterName] = filterValue;
                }
                toAdd = { ...transformed, ...toAdd };
                transformed = { ...toAdd };
            }
            for (let [filterName, filterValue] of Object.entries(transformed)) {
                if (filterValue === '' || filterValue === undefined) {
                    delete transformed[filterName];
                }
            }
            return transformed;
        },
        [datePostfixes.after, datePostfixes.before, findMapping, mapping, transformFromSetIfSingle]
    );

    return React.useMemo(() => paramsToApiCallParams(params), [params, paramsToApiCallParams]);
};

export default UseApiCallParams;
